import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca9754f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-table" }
const _hoisted_2 = { class: "t-table-header" }
const _hoisted_3 = { class: "t-table" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { "data-qe-id": "table-data" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }

import { RankingUi } from '@/model/CompetitionResult'

export default /*#__PURE__*/_defineComponent({
  __name: 'CResultTable',
  props: {
    data: {},
    onlyGameResult: { type: Boolean, default: false },
    state: { default: 'finished' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('resultView.table.headline')), 1),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('table.columns.rank')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('table.columns.playerName')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('table.columns.score')), 1),
          (!_ctx.onlyGameResult)
            ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(_ctx.$t('table.columns.tournamentScore')), 1))
            : _createCommentVNode("", true),
          (!_ctx.onlyGameResult)
            ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_ctx.$t('table.columns.tournamentRank')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (result) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: result.playerId,
            class: _normalizeClass({ highlighted: result.isOwnPlayer })
          }, [
            _createElementVNode("td", null, _toDisplayString(result.rank), 1),
            _createElementVNode("td", null, _toDisplayString(result.playerName), 1),
            (_ctx.state === 'pending' && !result.isOwnPlayer)
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.$t('resultView.table.state_pending_opponent')), 1))
              : (_ctx.state === 'pending' && result.isOwnPlayer)
                ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.$t('resultView.table.state_pending_myself')), 1))
                : (_ctx.state === 'lto')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, "-"))
                  : (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(result.score), 1)),
            (!_ctx.onlyGameResult)
              ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(result.tournamentScore), 1))
              : _createCommentVNode("", true),
            (!_ctx.onlyGameResult)
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(result.tournamentRank), 1))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})